import React from 'react';
import PropTypes from 'prop-types';
import CoverPhoto from './photo';
import CoverGuideLogo from './guide_logo';
import PartnerHeader from 'ui_system/headers/PartnerHeader';

export default class Cover extends React.Component {
  static displayName = 'Cover';
  static propTypes = {
    forInvoice: PropTypes.bool,
    tourPicture: PropTypes.string,
    guideAvatar: PropTypes.string,
    tourName: PropTypes.string,
    guideName: PropTypes.string,
    hasResource: PropTypes.bool,
    resourceName: PropTypes.string,
    linkColor: PropTypes.string,
    isLiveBooking: PropTypes.bool,
    businessName: PropTypes.string,
  };

  static defaultProps = {
    forInvoice: false,
    hasResource: false,
  };

  renderPartnerLiveHeader() {
    const { guideName, guideAvatar, tourName, brandColor, businessName } =
      this.props;
    return (
      <PartnerHeader
        isLiveHeader={true}
        bgColor={brandColor}
        title={businessName || tourName}
        logo={guideAvatar}
      />
    );
  }

  render() {
    const {
      tourPicture,
      guideAvatar,
      tourName,
      guideName,
      hasResource,
      resourceName,
      forInvoice,
      isLiveBooking,
      linkColor,
    } = this.props;

    if (forInvoice) {
      return (
        <CoverGuideLogo
          picture={guideAvatar}
          tourName={tourName}
          guideName={guideName}
          key="guide-logo"
        />
      );
    }

    if (isLiveBooking) {
      return this.renderPartnerLiveHeader();
    }

    return (
      <CoverPhoto
        picture={tourPicture}
        tourName={tourName}
        guideName={guideName}
        hasResource={hasResource}
        resourceName={resourceName}
        key="photo"
      />
    );
  }
}
